<app-loader [ShowLoader]="globalService.showLoader"></app-loader>

<!-- Inner Banner -->
<section id="hotel-inner-banner" class="content-section-outer clearfix inner-page-heading hotel-rooms">
    <h2 class="content-wrapper primary-text">{{'Preferences'|translate}}</h2>
    <div class="page-location content-wrapper">
        <a href="#" routerLink="/">{{'Home'|translate}}</a>
        <i class="material-icons">keyboard_arrow_right</i>
        <a routerLink="/preferences">{{'Preferences'|translate}}</a>
    </div>
</section>

<div class="content-wrapper-outer content-section-outer clearfix pt-4">
    <div class="content-wrapper">
        <div class="main-content-wrapper">
            <ng-template #noPreferencesState>
                <div class="no-preferences-state">{{'No preferences available'|translate}}</div>
            </ng-template>
            <mat-tab-group mat-align-tabs="start" class="filter-tab" (selectedTabChange)="onPreferenceTabChange($event)">
                <mat-tab [label]="'During Stay' | translate" class="nunito">
                    <ng-container *ngIf="dataSource?.length; else noPreferencesState">
                    <div class="preferences-block-wrapper">
                        <div class="preferences-block" *ngFor="let preference of dataSource">
                            <div class="preferences-block-header">
                                <mat-icon class="preference-icon" *ngIf="preference?.icon">{{ preference?.icon }}</mat-icon>
                                <h4 class="preferences-block-title">{{ getLocalizedValue(preference?.title || []) }}</h4>
                                <mat-slide-toggle [checked]="isPreferenceEnabled(preference)" (change)="onPreferenceToggle(preference, $event.checked)"></mat-slide-toggle>
                            </div>
                            <p class="mt-3" *ngIf="isPreferenceEnabled(preference)">{{ getLocalizedValue(preference?.description || []) }}</p>
                            <table mat-table [dataSource]="preference?.preferenceOptions || []" class="mat-elevation-z8" *ngIf="isPreferenceEnabled(preference) && isCheckboxType(preference?.preferenceOptionType)">
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> {{'Name'|translate}} </th>
                                    <td mat-cell *matCellDef="let element">{{ getLocalizedValue([element]) }}</td>
                                </ng-container>

                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef> {{'Action'|translate}} </th>
                                    <td mat-cell *matCellDef="let element">
                                        <mat-checkbox
                                            [checked]="isCheckboxChecked(element)"
                                            (change)="onCheckboxToggle(preference, element, $event.checked)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>

                            <div class="form-field-wrapper" *ngIf="isPreferenceEnabled(preference) && isRadioType(preference?.preferenceOptionType)">
                                <mat-radio-group [value]="getSelectedOptionId(preference)" (change)="onRadioSelect(preference, $event.value)">
                                    <mat-radio-button class="mr-3 mb-2" *ngFor="let element of preference?.preferenceOptions || []" [value]="element?._id">
                                        {{ getLocalizedValue([element]) }}
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>

                            <div class="form-field-wrapper mt-0" *ngIf="isPreferenceEnabled(preference) && isDropdownType(preference?.preferenceOptionType)">
                                <mat-form-field>
                                    <mat-select [placeholder]="'Select option' | translate" [value]="getSelectedOptionId(preference) || null" (selectionChange)="onDropdownSelect(preference, $event.value)">
                                        <mat-option *ngFor="let element of preference?.preferenceOptions || []" [value]="element?._id">
                                            {{ getLocalizedValue([element]) }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="form-field-wrapper mt-0" *ngIf="isPreferenceEnabled(preference) && isTextType(preference?.preferenceOptionType)">
                                <mat-form-field>
                                    <input matInput [value]="getSelectedTextValue(preference)" (input)="onTextValueChange(preference, $any($event.target).value)" />
                                </mat-form-field>
                            </div>

                            <span class="text-danger d-block mt-1" *ngIf="validationErrors[preference?._id]">{{ validationErrors[preference?._id] | translate }}</span>
                        </div>
                    </div>
                    <div class="pagination">
                        <span>
                            <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                                (page)="getPaginatorData($event)">
                            </mat-paginator>
                        </span>
                    </div>
                    </ng-container>
                </mat-tab>

                <mat-tab [label]="'Before Stay' | translate" class="nunito">
                    <ng-container *ngIf="dataSource?.length; else noPreferencesState">
                    <div class="preferences-block-wrapper">
                        <div class="preferences-block" *ngFor="let preference of dataSource">
                            <div class="preferences-block-header">
                                <mat-icon class="preference-icon" *ngIf="preference?.icon">{{ preference?.icon }}</mat-icon>
                                <h4 class="preferences-block-title">{{ getLocalizedValue(preference?.title || []) }}</h4>
                                <mat-slide-toggle [checked]="isPreferenceEnabled(preference)" (change)="onPreferenceToggle(preference, $event.checked)"></mat-slide-toggle>
                            </div>
                            <p class="mt-3" *ngIf="isPreferenceEnabled(preference)">{{ getLocalizedValue(preference?.description || []) }}</p>
                            <table mat-table [dataSource]="preference?.preferenceOptions || []" class="mat-elevation-z8" *ngIf="isPreferenceEnabled(preference) && isCheckboxType(preference?.preferenceOptionType)">
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> {{'Name'|translate}} </th>
                                    <td mat-cell *matCellDef="let element">{{ getLocalizedValue([element]) }}</td>
                                </ng-container>

                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef> {{'Action'|translate}} </th>
                                    <td mat-cell *matCellDef="let element">
                                        <mat-checkbox
                                            [checked]="isCheckboxChecked(element)"
                                            (change)="onCheckboxToggle(preference, element, $event.checked)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>

                            <div class="form-field-wrapper" *ngIf="isPreferenceEnabled(preference) && isRadioType(preference?.preferenceOptionType)">
                                <mat-radio-group [value]="getSelectedOptionId(preference)" (change)="onRadioSelect(preference, $event.value)">
                                    <mat-radio-button class="mr-3 mb-2" *ngFor="let element of preference?.preferenceOptions || []" [value]="element?._id">
                                        {{ getLocalizedValue([element]) }}
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>

                            <div class="form-field-wrapper mt-0" *ngIf="isPreferenceEnabled(preference) && isDropdownType(preference?.preferenceOptionType)">
                                <mat-form-field>
                                    <mat-select [placeholder]="'Select option' | translate" [value]="getSelectedOptionId(preference) || null" (selectionChange)="onDropdownSelect(preference, $event.value)">
                                        <mat-option *ngFor="let element of preference?.preferenceOptions || []" [value]="element?._id">
                                            {{ getLocalizedValue([element]) }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="form-field-wrapper mt-0" *ngIf="isPreferenceEnabled(preference) && isTextType(preference?.preferenceOptionType)">
                                <mat-form-field>
                                    <input matInput [value]="getSelectedTextValue(preference)" (input)="onTextValueChange(preference, $any($event.target).value)" />
                                </mat-form-field>
                            </div>

                            <span class="text-danger d-block mt-1" *ngIf="validationErrors[preference?._id]">{{ validationErrors[preference?._id] | translate }}</span>
                        </div>
                    </div>
                    <div class="pagination">
                        <span>
                            <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                                (page)="getPaginatorData($event)">
                            </mat-paginator>
                        </span>
                    </div>
                    </ng-container>
                </mat-tab>

                <mat-tab [label]="'After Stay' | translate" class="nunito">
                    <ng-container *ngIf="dataSource?.length; else noPreferencesState">
                    <div class="preferences-block-wrapper">
                        <div class="preferences-block" *ngFor="let preference of dataSource">
                            <div class="preferences-block-header">
                                <mat-icon class="preference-icon" *ngIf="preference?.icon">{{ preference?.icon }}</mat-icon>
                                <h4 class="preferences-block-title">{{ getLocalizedValue(preference?.title || []) }}</h4>
                                <mat-slide-toggle [checked]="isPreferenceEnabled(preference)" (change)="onPreferenceToggle(preference, $event.checked)"></mat-slide-toggle>
                            </div>
                            <p class="mt-3" *ngIf="isPreferenceEnabled(preference)">{{ getLocalizedValue(preference?.description || []) }}</p>
                            <table mat-table [dataSource]="preference?.preferenceOptions || []" class="mat-elevation-z8" *ngIf="isPreferenceEnabled(preference) && isCheckboxType(preference?.preferenceOptionType)">
                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> {{'Name'|translate}} </th>
                                    <td mat-cell *matCellDef="let element">{{ getLocalizedValue([element]) }}</td>
                                </ng-container>

                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef> {{'Action'|translate}} </th>
                                    <td mat-cell *matCellDef="let element">
                                        <mat-checkbox
                                            [checked]="isCheckboxChecked(element)"
                                            (change)="onCheckboxToggle(preference, element, $event.checked)">
                                        </mat-checkbox>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>

                            <div class="form-field-wrapper" *ngIf="isPreferenceEnabled(preference) && isRadioType(preference?.preferenceOptionType)">
                                <mat-radio-group [value]="getSelectedOptionId(preference)" (change)="onRadioSelect(preference, $event.value)">
                                    <mat-radio-button class="mr-3 mb-2" *ngFor="let element of preference?.preferenceOptions || []" [value]="element?._id">
                                        {{ getLocalizedValue([element]) }}
                                    </mat-radio-button>
                                </mat-radio-group>
                            </div>

                            <div class="form-field-wrapper mt-0" *ngIf="isPreferenceEnabled(preference) && isDropdownType(preference?.preferenceOptionType)">
                                <mat-form-field>
                                    <mat-select [placeholder]="'Select option' | translate" [value]="getSelectedOptionId(preference) || null" (selectionChange)="onDropdownSelect(preference, $event.value)">
                                        <mat-option *ngFor="let element of preference?.preferenceOptions || []" [value]="element?._id">
                                            {{ getLocalizedValue([element]) }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>

                            <div class="form-field-wrapper mt-0" *ngIf="isPreferenceEnabled(preference) && isTextType(preference?.preferenceOptionType)">
                                <mat-form-field>
                                    <input matInput [value]="getSelectedTextValue(preference)" (input)="onTextValueChange(preference, $any($event.target).value)" />
                                </mat-form-field>
                            </div>

                            <span class="text-danger d-block mt-1" *ngIf="validationErrors[preference?._id]">{{ validationErrors[preference?._id] | translate }}</span>
                        </div>
                    </div>
                    <div class="pagination">
                        <span>
                            <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
                                (page)="getPaginatorData($event)">
                            </mat-paginator>
                        </span>
                    </div>
                    </ng-container>
                </mat-tab>
            </mat-tab-group>

            <button class="btn btn-success d-flex align-items-center justify-content-between" (click)="goToSelectedPreferences()" [disabled]="!selectedPreferences?.length">
                <span class="pull-left">{{ 'Checkout' | translate }}({{ selectedPreferences?.length || 0 }})</span>
                <i class="material-icons pull-right ml-3 mr-0">arrow_forward</i>
            </button>
        </div>
    </div>
</div>